import React, { useState, useEffect } from "react";
import ListHeader from "../../issuanceIDcard/studentList/ListHeader";
// import DlpSearchInput from "../studentList/DlpSearchInput";
// import SelectFilterChip from "./SelectFilterChip";
import { useGetDlpModuleContext } from "../contextApi/dlpContext";
import FilterForm from "./FilterForm";
import ModuleCards from "./ModuleCards";
import ALoader from "views/pages/manage/common/a-loader";
import BranchConsumptionReturnPopup from "../consumptionReturn";
import DisabledModulesAlert, {
  showDisabledModuleAlert,
  checkDisabledModuleList,
  checkDisabledModule,
} from "../../stockManagement/studentList/DisabledModulesAlert";

import { useFetchDispatchScheduleDropdown } from "../customhooks";
import { useFetchDropdown } from "../../issuanceIDcard/customhooks";
import StockTransactionsHistoryPopup from "../stockTxns";
import DownloadReportsDialog from "../downloadReports/DownloadReportsDialog";
import AddToFavourite from "../../../homepage/favourites/AddToFavourite";
import { pages } from "views/pages/manage/common/constant";
import { fetchAllPromisedData } from "../../../common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../../common/constant";

const ApplicationFilterLandingPage = ({ disabled }) => {
  const {
    selectedFilter,
    setSelectedFilter,
    isApplicationLoading,
    loading,
    filterForm,
    dropdown,
  } = useGetDlpModuleContext();

  const [dropdownDlp, loader] = useFetchDropdown("DLP");
  const [apiLoader, setApiLodaer] = useState(false);

  const [dispatchScheduleDropdown, isDropdownLoading] =
    useFetchDispatchScheduleDropdown(filterForm);
  const [isStockTxnDialogOpen, setIsStockTxnDialogOpen] = useState(false);
  const [
    isStockConsumptionReturnDialogOpen,
    setIsStockConsumptionReturnDialogOpen,
  ] = useState(false);

  const [isDownloadReportsDialogOpen, setIsDownloadReportsDialogOpen] =
    useState(false);

  const [disabledModulesDetails, setDisabledModulesDetails] = useState({});

  useEffect(() => {
    // if (dropdown?.businessAreas) {
    getDisabledModules();
    // }
  }, []);

  const stockConsumptionReturnHandler = () => {
    setIsStockConsumptionReturnDialogOpen(true);
  };

  const stockTxnHandler = () => {
    setIsStockTxnDialogOpen(true);
  };

  const downloadReportsClickHandler = () =>
    setIsDownloadReportsDialogOpen(true);

  const getDisabledModules = async () => {
    setApiLodaer(true);
    const res = await fetchAllPromisedData(
      endpoint?.studentSearch?.getDisabledStockModules,
      true
    );
    if (res?.code === 200) {
      const moduleDetails = {};
      for (const module of checkDisabledModuleList) {
        moduleDetails[module] = checkDisabledModule(module, [], res?.data);
      }
      setDisabledModulesDetails(moduleDetails);
    } else {
      setDisabledModulesDetails({});
    }
    setApiLodaer(false);
  };

  return (
    <div className="" style={{ marginTop: "-1rem" }}>
      {showDisabledModuleAlert(disabledModulesDetails) && (
        <DisabledModulesAlert />
      )}

      <div className="p-3 student-filer-container-printId">
        {(loading ||
          isApplicationLoading ||
          isDropdownLoading ||
          apiLoader) && <ALoader position="fixed" />}

        <div className="d-flex align-items-center justify-content-between">
          <ListHeader text="Search students to mark eligible to issue stocks" />
          <AddToFavourite
            screenName={pages["dlpStockAndInventory"]["name"]}
            screenId={pages["dlpStockAndInventory"]["id"]}
          />
        </div>
        {/* <SelectFilterChip
          isHideSingle = {true}
          selectedFilter={selectedFilter}
          setSelectedFilter={setSelectedFilter}
        /> */}
        {/* <DlpSearchInput disabled={selectedFilter !== "SINGLE"} /> */}

        <FilterForm
          disabled={selectedFilter !== "BULK"}
          dispatchScheduleDropdown={dispatchScheduleDropdown}
        />
      </div>
      <ModuleCards
        stockTxnHandler={stockTxnHandler}
        disabledModulesDetails={disabledModulesDetails}
        stockConsumptionReturnHandler={stockConsumptionReturnHandler}
        downloadReportsClickHandler={downloadReportsClickHandler}
      />
      <BranchConsumptionReturnPopup
        open={isStockConsumptionReturnDialogOpen}
        setOpen={setIsStockConsumptionReturnDialogOpen}
        dropdown={dropdownDlp}
        academicType="DLP"
        forDlp={true}
      />
      <StockTransactionsHistoryPopup
        open={isStockTxnDialogOpen}
        setOpen={setIsStockTxnDialogOpen}
        dropdown={dropdown}
        academicType="DLP"
        forDlp={true}
      />

      <DownloadReportsDialog
        dropdown={dropdown}
        open={isDownloadReportsDialogOpen}
        setOpen={setIsDownloadReportsDialogOpen}
        forDlp={true}
      />
    </div>
  );
};

export default ApplicationFilterLandingPage;
